import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { formatQueryParams } from '@utils/Format'
import {
  APPROVALS_PENDING,
  APPROVAL_APPROVE,
  APPROVAL_REJECT,
} from '@modules/ai-framework/constants/URL'

const ERRO_INESPERADO = 'Erro inesperado. Tente novamente mais tarde.'

// `location='json'` no reqparse dos resources de aprovar/rejeitar: sem o opt-in o
// `connection.js` manda FormData, o `request.get_json()` do Flask estoura e a decisão
// nunca é gravada — a fila fica parada sem erro visível. Ver apiAiFrameworkInstances.js.
const ENVIAR_JSON = { json: true }

function requireDecisionKey(idRun, ordemStep) {
  const missingRun = idRun === undefined || idRun === null || idRun === ''
  const missingStep = ordemStep === undefined || ordemStep === null || ordemStep === ''
  if (missingRun || missingStep) {
    return { status: 400, message: 'id_run e ordem_step obrigatórios', value: null }
  }
  return null
}

// Fila de aprovações do gestor (spec-004, grupo A). Cada método lê `response.data.status`
// do BODY (HTTP-200-always — o backend responde sempre HTTP 200). Nenhum payload carrega
// `model`/`system_prompt`/prompt — a proposta já vem minimizada (allowlist NC-3).
class APIAiFrameworkApprovals extends APITemplate {
  // GET /approvals/pending — filtros opcionais (agente/autor/período).
  async listPending({ idInstance, idProfissional, de, ate } = {}) {
    const params = formatQueryParams({
      id_instance: idInstance,
      id_profissional: idProfissional,
      de: de,
      ate: ate,
    })
    const r = await con.get(APPROVALS_PENDING + params)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  // POST /approvals/:id_run/steps/:ordem_step/approve — justificativa opcional.
  async approve(idRun, ordemStep, { justificativa = null } = {}) {
    const guard = requireDecisionKey(idRun, ordemStep)
    if (guard) return guard
    const r = await con.post(
      APPROVAL_APPROVE(idRun, ordemStep), { justificativa: justificativa }, false, ENVIAR_JSON,
    )
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  // POST /approvals/:id_run/steps/:ordem_step/reject — justificativa obrigatória (400 se vazia).
  async reject(idRun, ordemStep, { justificativa } = {}) {
    const guard = requireDecisionKey(idRun, ordemStep)
    if (guard) return guard
    const r = await con.post(
      APPROVAL_REJECT(idRun, ordemStep), { justificativa: justificativa }, false, ENVIAR_JSON,
    )
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }
}

// Singleton no padrão do projeto: instância nomeada + export explícito.
// A classe NÃO é exportada — ninguém a consome (verificado por grep em src/),
// e export sem consumidor é código morto que o próximo leitor tenta preservar.
const apiAiFrameworkApprovals = new APIAiFrameworkApprovals()

export { apiAiFrameworkApprovals }
